export type StatisticsAction = { type: 'GET_STATISTICS' } | { type: 'POST_STATISTICS' };

export function getStatistics(): StatisticsAction {
  return { type: 'GET_STATISTICS' };
}

export function postStatistics(): StatisticsAction {
  return { type: 'POST_STATISTICS' };
}
